<template>
  <div class="help-center">
    <!-- 左侧导航 -->
    <div class="sidebar">
      <div class="logo">
        <i class="fas fa-question-circle"></i>
        <h1>{{ $t('_bzzx._bzzx') }}</h1>
      </div>
      <ul class="nav-menu">
        <li v-for="(item, index) in navItems" :key="index" :class="['nav-item', { active: activeNav === index }]" @click="activeNav = index">
          <i :class="item.icon"></i>
          <span>{{ item.title }}</span>
        </li>
      </ul>
    </div>

    <!-- 右侧内容 -->
    <div class="content">
      <div class="content-header">
        <h2>{{ activeNavItem.title }}</h2>
        <p>{{ activeNavItem.description }}</p>
      </div>

      <!-- <div class="search-box">
        <i class="fas fa-search"></i>
        <input type="text" placeholder="搜索问题或关键词..." v-model="searchQuery" />
      </div> -->

      <div class="faq-section" v-for="(section, index) in activeNavItem.sections" :key="index">
        <h3 class="section-title">
          <i :class="section.icon"></i>
          {{ section.title }}
        </h3>
        <ul class="faq-list">
          <li v-for="(faq, faqIndex) in section.faqs" :key="faqIndex" :class="['faq-item active', { active: faq.active }]" @click="toggleFaq(faq)">
            <div class="faq-question">
              <span>{{ faq.question }}</span>
              <i class="fas fa-chevron-down"></i>
            </div>
            <div class="faq-answer">
              <p>{{ faq.answer }}</p>
            </div>
          </li>
        </ul>
      </div>

      <div class="contact-section">
        <h3 class="contact-title">{{ $t('_bzzx._myzdwt') }}</h3>
        <p class="contact-desc">{{ $t('_bzzx._khjybbzn') }}</p>
        <a href="#" class="contact-btn"> <i class="fas fa-headset"></i> {{ $t('_bzzx._lxkf') }} </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HelpCenter',
  data() {
    return {
      activeNav: 0,
      searchQuery: '',
      navItems: [
        {
          title: this.$t('_bzzx._rhzczh'),
          description: '',
          icon: 'fas fa-user-plus',
          sections: [
            {
              title: '',
              icon: 'fas fa-list-ol',
              faqs: [
                {
                  question: this.$t('_bzzx._rhzcxyh'),
                  answer: this.$t('_bzzx._rhzcxyh1'),
                  active: false
                }
              ]
            }
          ]
        },
        {
          title: this.$t('_bzzx._rhcz'),
          description: '',
          icon: 'fas fa-envelope',
          sections: [
            {
              title: '',
              icon: 'fas fa-envelope-open-text',
              faqs: [
                {
                  question: this.$t('_bzzx._rhcz2'),
                  answer: this.$t('_bzzx._rhcz3'),
                  active: false
                }
              ]
            }
          ]
        },
        {
          title: this.$t('_bzzx._rhjsdj'),
          description: '',
          icon: 'fas fa-crown',
          sections: [
            {
              title: '',
              icon: 'fas fa-gem',
              faqs: [
                {
                  question: this.$t('_bzzx._rhjsdj'),
                  answer: this.$t('_bzzx._rhjsdj2'),
                  active: false
                }
              ]
            }
          ]
        },
        {
          title: this.$t('_bzzx._rhtx'),
          description: '',
          icon: 'fas fa-coins',
          sections: [
            {
              title: '',
              icon: 'fas fa-wallet',
              faqs: [
                {
                  question: this.$t('_bzzx._rhtx'),
                  answer: this.$t('_bzzx._rhtx1'),
                  active: false
                }
              ]
            }
          ]
        },
        // {
        //   title: '账户问题',
        //   description: '解决账户登录、安全等相关问题',
        //   icon: 'fas fa-user-shield',
        //   sections: [
        //     {
        //       title: '登录问题',
        //       icon: 'fas fa-sign-in-alt',
        //       faqs: [
        //         {
        //           question: '无法登录账户怎么办？',
        //           answer: '请检查网络连接，确认账号密码正确。如忘记密码可使用"找回密码"功能。',
        //           active: false
        //         }
        //       ]
        //     }
        //   ]
        // },
        {
          title: this.$t('_bzzx._qtwt'),
          description: '',
          icon: 'fas fa-ellipsis-h',
          sections: [
            {
              title: '',
              icon: 'fas fa-question',
              faqs: [
                {
                  question: this.$t('_bzzx._qtwt1'),
                  answer: this.$t('_bz._lxkf'),
                  active: false
                }
              ]
            }
          ]
        }
      ]
    }
  },
  computed: {
    activeNavItem() {
      return this.navItems[this.activeNav]
    }
  },
  methods: {
    toggleFaq(faq) {
      faq.active = !faq.active
    }
  }
}
</script>

<style scoped>
.help-center {
  display: flex;
  max-width: 1200px;
  margin: 0 auto;
  background: #1a1f26;
  border-radius: 12px;
  border: 1px solid #2a3038;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.3);
  overflow: hidden;
  min-height: 600px;
}

.sidebar {
  width: 280px;
  background: linear-gradient(135deg, #14181c 0%, #1a1f26 100%);
  color: #e8edf2;
  padding: 30px 0;
  border-right: 1px solid #2a3038;
}

.logo {
  display: flex;
  align-items: center;
  padding: 0 25px 25px;
  border-bottom: 1px solid #2a3038;
  margin-bottom: 20px;
}

.logo i {
  font-size: 24px;
  margin-right: 10px;
  color: #ffb300;
}

.logo h1 {
  font-size: 22px;
  font-weight: 600;
  color: #fff;
}

.nav-menu {
  list-style: none;
}

.nav-item {
  padding: 14px 25px;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  border-left: 4px solid transparent;
  color: #8a949f;
}

.nav-item:hover {
  background: #14181c;
  color: #e8edf2;
}

.nav-item.active {
  background: #14181c;
  border-left: 4px solid #ffb300;
  color: #ffb300;
}

.nav-item i {
  width: 24px;
  margin-right: 12px;
  font-size: 16px;
}

.content {
  flex: 1;
  padding: 40px;
}

.content-header {
  margin-bottom: 30px;
}

.content-header h2 {
  font-size: 28px;
  color: #e8edf2;
  margin-bottom: 10px;
}

.content-header p {
  color: #8a949f;
  font-size: 16px;
}

.search-box {
  position: relative;
  margin-bottom: 30px;
}

.search-box input {
  width: 100%;
  padding: 14px 20px 14px 50px;
  border: 1px solid #2a3038;
  border-radius: 8px;
  font-size: 16px;
  background: #0a0d0f;
  color: #e8edf2;
  transition: all 0.3s;
}

.search-box input:focus {
  outline: none;
  border-color: #ffb300;
  box-shadow: 0 0 0 3px rgba(255, 179, 0, 0.2);
}

.search-box i {
  position: absolute;
  left: 18px;
  top: 50%;
  transform: translateY(-50%);
  color: #4a5662;
  font-size: 18px;
}

.faq-section {
  margin-bottom: 35px;
}

.section-title {
  font-size: 20px;
  color: #e8edf2;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 1px solid #2a3038;
  display: flex;
  align-items: center;
}

.section-title i {
  margin-right: 10px;
  color: #ffb300;
}

.faq-list {
  list-style: none;
}

.faq-item {
  background: #0a0d0f;
  border-radius: 8px;
  margin-bottom: 12px;
  overflow: hidden;
  transition: all 0.3s;
  border: 1px solid #2a3038;
}

.faq-item:hover {
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.3);
  border-color: #ffb300;
}

.faq-question {
  padding: 18px 20px;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: 500;
  color: #e8edf2;
}

.faq-question i {
  transition: transform 0.3s;
  color: #8a949f;
}

.faq-answer {
  padding: 0 20px;
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.3s, padding 0.3s;
  background: #14181c;
  color: #8a949f;
}

.faq-item.active .faq-answer {
  padding: 0 20px 20px;
  max-height: 500px;
}

.faq-item.active .faq-question i {
  transform: rotate(180deg);
}

.contact-section {
  background: linear-gradient(135deg, #14181c 0%, #1a1f26 100%);
  border-radius: 10px;
  padding: 25px;
  margin-top: 40px;
  border: 1px solid #2a3038;
}

.contact-title {
  font-size: 20px;
  margin-bottom: 15px;
  color: #e8edf2;
}

.contact-desc {
  color: #8a949f;
  margin-bottom: 20px;
}

.contact-btn {
  display: inline-block;
  background: linear-gradient(135deg, #ffb300, #f57c00);
  color: #0b0d0f;
  padding: 12px 25px;
  border-radius: 6px;
  text-decoration: none;
  font-weight: 600;
  transition: background 0.3s;
}

.contact-btn:hover {
  background: linear-gradient(135deg, #f57c00, #ffb300);
}


@media (max-width: 768px) {
  .help-center {
    flex-direction: column;
    /* margin: 15px; */
  }

  .sidebar {
    width: 100%;
  }
}
</style>
